import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { SearchForm } from 'components/common';

const HomeHeaderSearch = () => {
  const { messages } = useReduxState();

  const router = useRouter();

  const handleSearch = (searchString: string) => {
    router.push(`/search?searchString=${searchString}`);
  };

  const validateSearchString = (value: string) => {
    if (value && value.trim().length > 1) return undefined;
    return messages.searchMinimumLengthError;
  };

  return (
    <SearchForm
      onSearch={handleSearch}
      placeholderText={messages.commonSearch}
      validate={validateSearchString}
    />
  );
};

export default HomeHeaderSearch;
